<template lang="pug">
  .good-luck
    Frame
      .good-luck__title Поздравляем,<br>вы готовы к Бобровой гонке!
      p.good-luck__text Помните, что это ваш шанс победить<br>и помочь Новогодним Бобрам.<br>Удачи!
      Buttons(type="next")
</template>

<script>
import { mapGetters } from 'vuex';
import Frame from '@/components/UI/Frame';
import Buttons from '@/components/UI/Buttons';

export default {
  name: 'GoodLuck',
  components: { Frame, Buttons },
  computed: {
    ...mapGetters(['isLicense']),
  },
};
</script>

<style scoped lang="scss">
  .good {
    &-luck {
      &__title {
        @include typo-h1($weight: normal);
        color: $clr-hoverMain;
        padding-top: 30px;
      }
      &__subtitle {
        @include typo-h1;
        color: $clr-darkMain;
        margin: 44px 0 0;
        @media (max-width: $max-width-xs) {
          margin: 34px 0 0;
        }
      }
      &__text {
        @include typo-text;
        color: $clr-blue;
        margin: 30px 0 0;
        @media (max-width: $max-width-xs) {
          @include typo-p(normal);
          margin: 11px 0 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/GoodLuck.vue